import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { HOME_CONTENT_MOCK } from '../data/home-content.mock';
import type {
  HomeVisionBannersActivosResponse,
  HomeVisionBannerRow,
  HomeVisionContent,
} from '../models/home-vision-content.model';
import { mapVisionBannersToContent } from '../utils/home-vision-banner.mapper';
import { prepareVisionButtonHtml, prepareVisionTitleHtml } from '../utils/home-vision-html.util';

/** Debe coincidir con `NeoBannerDTO.VISION_NEGOCIO` */
export const VISION_BANNER_TIPO = 'VisionNegocio';

@Injectable({
  providedIn: 'root',
})
export class HomeVisionService {
  private readonly fallbackContent: HomeVisionContent = buildVisionFallbackFromMock();

  constructor(private readonly bancoldexService: BancoldexService) {}

  loadContent(): Observable<HomeVisionContent> {
    return this.bancoldexService.getArchivosBannerActivos(VISION_BANNER_TIPO).pipe(
      map((response: HomeVisionBannersActivosResponse) => {
        const rows = normalizeVisionBannerRows(response);
        if (!rows.length) {
          return this.fallbackContent;
        }
        return mapVisionBannersToContent(rows, this.fallbackContent);
      }),
      catchError(() => of(this.fallbackContent))
    );
  }
}

function buildVisionFallbackFromMock(): HomeVisionContent {
  const mock = HOME_CONTENT_MOCK.ctaFinal;
  return {
    eyebrow: mock.eyebrow,
    titleHtml: prepareVisionTitleHtml(mock.title),
    descripcionEspecifica: mock.description,
    buttonLabel: prepareVisionButtonHtml(mock.buttonLabel),
    buttonUrl: mock.buttonUrl,
  };
}

function normalizeVisionBannerRows(
  response: HomeVisionBannersActivosResponse
): HomeVisionBannerRow[] {
  if (!response?.exitoso || !response.banners?.length) {
    return [];
  }

  const first = response.banners[0] as unknown;
  if (Array.isArray(first)) {
    return (response.banners as HomeVisionBannerRow[][]).flat();
  }

  return response.banners as HomeVisionBannerRow[];
}
